{
  "version": 1,
  "asset_id": "2bd8bcbe-aa61-4815-b444-d5dc0cfdc4bc",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/2bd8bcbe-aa61-4815-b444-d5dc0cfdc4bc/sleeve-amateur-3-220.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/2bd8bcbe-aa61-4815-b444-d5dc0cfdc4bc/sleeve-amateur-3-220.png",
  "original_filename": "sleeve-amateur-3-220.png",
  "size": 41059,
  "content_type": "image/png",
  "created_at": "2026-09-29T01:15:38Z"
}
